/**
 * Copyright © 2024 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import { gql } from '@apollo/client'

const DASHBOARD_SUMMARY_STAT_FRAGMENT = gql`
  fragment DashboardSummaryStat on DashboardSummaryStat {
    label
    tooltip
    value
    valueType
    totalValue
    percentShareLabels {
      primary
      secondary
    }
    multiShare {
      label
      value
    }
    previousValue
    previousTotalValue
    percentChange
  }
`

export const GET_DASHBOARD_SUMMARY_STAT = gql`
  query GetDashboardSummaryStat($input: AdminDashboardInput!) {
    dashboardSummaryStat(input: $input) {
      ...DashboardSummaryStat
    }
  }
  ${DASHBOARD_SUMMARY_STAT_FRAGMENT}
`

const DASHBOARD_STAT_USER_RANK_FRAGMENT = gql`
  fragment DashboardStatUserRank on DashboardSummaryStat {
    label
    value
    valueType
    totalValue
  }
`

export const GET_DASHBOARD_STAT_USER_RANK = gql`
  query GetDashboardStatUserRank($input: AdminDashboardInput!) {
    dashboardStatUserRank(input: $input) {
      ...DashboardStatUserRank
    }
  }
  ${DASHBOARD_STAT_USER_RANK_FRAGMENT}
`
